export default __webpack_public_path__ + "static/media/inactiveright.be2e2ea0.svg";